
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myaccount/address",
      function () {
        return require("private-next-pages/myaccount/address.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myaccount/address"])
      });
    }
  